import React, { Component } from 'react';
import DeliveryDetailsMap from "./DeliveryDetailsMap";
import DeliveryDetailsTimelineItem from './DeliveryDetailsTimelineItem';
import DeliveryDetailsAddress from './DeliveryDetailsAddress';

class DeliveryDetailsPending extends Component {

	render() {

		const props = this.props;

		const delivery = this.props.delivery;
		const deliveryConfig = this.props.deliveryConfig;
		const styles = deliveryConfig.clientStyles;
		const { boxes, scanLog } = delivery;

		const scanLogFiltered = Array.from(new Set(scanLog.map(a => a.status)))
			.map(status => {
				return scanLog.find(a => a.status === status)
			});

		return (
			<div className="deliveryDetails row">
				<div className="col-12">
					<DeliveryDetailsMap
						lang={props.lang}s
						latitude={delivery.latitude}
						longitude={delivery.longitude}
						deliveryConfig={deliveryConfig}
					/>

					{boxes &&
						<DeliveryDetailsAddress
							lang={props.lang}
							delivery={delivery}
							styles={styles}
							boxes={boxes}
						/>
					}

					{scanLogFiltered && scanLogFiltered.length > 0 &&
						<div className="row pt-3 division white-bg timeline-container">
							{scanLogFiltered.map((data) =>
								<DeliveryDetailsTimelineItem
									lang={props.lang}
									key={data.scannedDt}
									styles={styles}
									data={data}
								/>
							)}
						</div>
					}

					<p className="row">&nbsp;</p>
				</div>
			</div>
		);
	}
}

export default DeliveryDetailsPending
